export default __webpack_public_path__ + "static/media/single-project-page-03-img14.0d075c48.jpg";